import { validateRedirectPath } from "@/lib/utils";

export const AUTH_REDIRECT_STORAGE_KEY = "aideco_auth_redirect";

/** Sanitize a redirect value — returns safe internal path or fallback */
export function sanitizeAuthRedirect(
  value: string | null | undefined,
  fallback = "/dashboard",
): string {
  return value ? validateRedirectPath(value, fallback) : fallback;
}

/** Persist a sanitized redirect to localStorage */
export function persistAuthRedirect(
  value: string | null | undefined,
  fallback = "/dashboard",
): string {
  const safeValue = sanitizeAuthRedirect(value, fallback);
  try {
    localStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, safeValue);
  } catch {
    // localStorage unavailable (SSR, private browsing)
  }
  return safeValue;
}

/** Read and sanitize the stored redirect, returning fallback if missing/invalid */
export function readAuthRedirect(fallback = "/dashboard"): string {
  try {
    const stored = localStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
    return sanitizeAuthRedirect(stored, fallback);
  } catch {
    return fallback;
  }
}

/** Clear the stored redirect */
export function clearAuthRedirect(): void {
  try {
    localStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
  } catch {
    // localStorage unavailable
  }
}
